// extracted by mini-css-extract-plugin
var _1 = "ListItem-moduleavatar__xFm3e";
var _2 = "ListItem-modulelistItem__shTrV";
export { _1 as "avatar", _2 as "listItem" }
